import './MaintenanceOptOurErrorInstructions.scss';

import React from 'react';
import { educationAuthTokenUrls } from 'services/Externals';

const MaintenanceOptOutErrorInstructions = () => {
  return <div className="maintenance-opt-out-error">
    <h2>Something went wrong</h2>
    <div className="maintenance-opt-out-error-content">
      There was an issue with your request. Please try again later. If the problem persists, you can
      {' '}
      <a
        className="error-page-link"
        href={educationAuthTokenUrls.contactUrl}
        rel="noreferrer"
        target="_blank"
      >
        contact us
      </a>
      .
    </div>
  </div>
};

export default MaintenanceOptOutErrorInstructions
